export default "__VITE_ASSET__DFxeuTvG__"